import constants from '../constants/index';

const ScheduleControlsActions = {
	selectControlsMenuItem: function(id, selected) {
		return {
			type: constants.SELECT_CONTROLS_MENU_ITEM,
			payload: {
				id: id,
				selected: selected
			}
		};
	},

  selectLayersMenuItem: function(selected) {
    return {
      type: constants.SELECT_LAYERS_MENU_ITEM,
      payload: {
        selected: selected
      }
    };
  }
};

export default ScheduleControlsActions;


/** WEBPACK FOOTER **
 ** ./src/js/actions/schedule_controls_actions.js
 **/